import { Popover } from "@headlessui/react";
import { Fade, Popper } from "@mui/material";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import {
  createRef,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";

type NavSelectorProps<T> = {
  items: { key: T; name: string }[];
  label: string;
  activeItem: T;
  setActiveItem: Dispatch<SetStateAction<T>>;
};

export default function NavSelector<T>({
  items,
  label,
  activeItem,
  setActiveItem,
}: NavSelectorProps<T>) {
  const ref = createRef<HTMLDivElement>();
  const [pref, setPref] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    setPref(ref.current);
  }, []);
  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <div ref={ref}>
            <Popover.Button
              className={clsx(
                "group relative inline-flex flex-row items-center rounded-md bg-succinct-neon py-2 px-3 font-sans-regular text-black focus:outline-none"
              )}
            >
              <span>{label}</span>
              <ChevronDownIcon
                className={clsx("ml-2 mb-0.5 h-5 w-5")}
                aria-hidden="true"
              />
            </Popover.Button>
          </div>

          <Popper anchorEl={pref} open={open} placement="bottom" transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps}>
                <div>
                  <Popover.Panel className="relative left-0 z-10 mt-1 transform">
                    <div className="overflow-hidden rounded-lg text-sm shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="bg-gray-50 text-gray-900">
                        {items.map(({ key, name }) => (
                          <button
                            key={name}
                            onClick={() => {
                              setActiveItem(key);
                              close();
                            }}
                            className={clsx(
                              "block w-full rounded-md px-4 py-2 hover:bg-gray-200",
                              key === activeItem && "bg-gray-200"
                            )}
                          >
                            {name}
                          </button>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </div>
              </Fade>
            )}
          </Popper>
        </>
      )}
    </Popover>
  );
}
